module.exports = __webpack_public_path__ + "static/p4-3ac079aeb4a6e2e11cd31d50d7f452d1.png";